module.exports = __webpack_public_path__ + "img/ginsho.7e3a5581.png";